import { Box } from '@mui/material';
import {
  DataGridPremium,
  DataGridPremiumProps,
} from '@mui/x-data-grid-premium';

export const BluDataGridPremium = (props: DataGridPremiumProps) => {
  return (
    <Box sx={{ flex: 1, position: 'relative', ...props.sx }}>
      <DataGridPremium {...props} sx={{ position: 'absolute', inset: 0 }} />
    </Box>
  );
};
